import { useQuery, useMutation } from '@tanstack/react-query';
import {
  validateRecaptureProduct,
  recaptureProduct,
} from 'services/payment/index';

export const useValidateRecaptureProduct = () =>
  useMutation({
    mutationFn: validateRecaptureProduct,
  });

export const useRecaptureProduct = () =>
  useMutation({
    mutationFn: recaptureProduct,
  });
